<dx-responsive-box
  #emailCommunicationContainer
  class="email-communication-container"
>
  <dxi-row></dxi-row>
  <dxi-row></dxi-row>
  <dxi-row></dxi-row>
  <dxi-row></dxi-row>
  <dxi-row></dxi-row>
  <dxi-row></dxi-row>
  <dxi-row></dxi-row>

  <dxi-col></dxi-col>
  <dxi-col></dxi-col>
  <dxi-col screen="md lg"></dxi-col>

  <ng-container *ngIf="!isUserCreated">
    <!-- Subtitle -->
    <dxi-item>
      <dxi-location
        screen="md lg"
        [row]="0"
        [col]="0"
        [colspan]="3"
      ></dxi-location>
      <dxi-location
        screen="xs sm"
        [row]="0"
        [col]="0"
        [colspan]="2"
      ></dxi-location>
      <div *dxTemplate class="input-container">
        <div class="input-wrapper subtitle-container">
          Please choose the following email communication preferences.
        </div>
      </div>
    </dxi-item>

    <!-- Electronic Statements -->
    <dxi-item>
      <dxi-location
        screen="md lg"
        [row]="1"
        [col]="0"
        [colspan]="3"
      ></dxi-location>
      <dxi-location
        screen="xs sm"
        [row]="1"
        [col]="0"
        [colspan]="2"
      ></dxi-location>
      <div *dxTemplate class="input-container">
        <div class="input-wrapper preference-section">
          <div class="preference-header">
            <dx-switch
              class="switch-input"
              [(value)]="electronicStatementsEnabled"
            ></dx-switch>
          </div>
          <div class="preference-title">Electronic Statements</div>
          <div class="preference-description">
            Receive account updates faster and help reduce environmental impact
            by opting into electronic notifications instead of standard mail.
          </div>
        </div>
      </div>
    </dxi-item>

    <!-- Standard Notices -->
    <dxi-item>
      <dxi-location
        screen="md lg"
        [row]="2"
        [col]="0"
        [colspan]="3"
      ></dxi-location>
      <dxi-location
        screen="xs sm"
        [row]="2"
        [col]="0"
        [colspan]="2"
      ></dxi-location>
      <div *dxTemplate class="input-container">
        <div class="input-wrapper preference-section">
          <div class="preference-header">
            <dx-switch
              class="switch-input"
              [(value)]="standardNoticesEnabled"
            ></dx-switch>
          </div>
          <div class="preference-title">Standard Notices</div>
          <div class="preference-description">
            Receive standard community notices that share upcoming events and
            updates like National Night Out or new pool hours.
          </div>
        </div>
      </div>
    </dxi-item>

    <!-- Emergency Notices -->
    <dxi-item>
      <dxi-location
        screen="md lg"
        [row]="3"
        [col]="0"
        [colspan]="3"
      ></dxi-location>
      <dxi-location
        screen="xs sm"
        [row]="3"
        [col]="0"
        [colspan]="2"
      ></dxi-location>
      <div *dxTemplate class="input-container">
        <div class="input-wrapper preference-section">
          <div class="preference-header">
            <dx-switch
              class="switch-input"
              [(value)]="emergencyNoticesEnabled"
            ></dx-switch>
          </div>
          <div class="preference-title">Emergency Notices</div>
          <div class="preference-description">
            Receive emergency communications that provide urgent updates such as
            freeze warnings, boil water notices, or community road and facility
            closures.
          </div>
        </div>
      </div>
    </dxi-item>

    <!-- Back Button -->
    <dxi-item>
      <dxi-location
        screen="md lg"
        [row]="4"
        [col]="0"
        [colspan]="3"
      ></dxi-location>
      <dxi-location
        screen="xs sm"
        [row]="4"
        [col]="0"
        [colspan]="2"
      ></dxi-location>
      <div *dxTemplate class="btn-wrapper">
        <dx-button
          text="Back"
          class="back-button"
          type="default"
          (onClick)="btnPreviousClick()"
        ></dx-button>
      </div>
    </dxi-item>

    <!-- Continue Button -->
    <dxi-item>
      <dxi-location
        screen="md lg"
        [row]="5"
        [col]="0"
        [colspan]="3"
      ></dxi-location>
      <dxi-location
        screen="xs sm"
        [row]="5"
        [col]="0"
        [colspan]="2"
      ></dxi-location>
      <div *dxTemplate class="btn-wrapper">
        <dx-button
          text="Continue"
          class="continue-button"
          type="default"
          (onClick)="btnNextClick()"
        ></dx-button>
      </div>
    </dxi-item>

    <!-- Sign In Link -->
    <dxi-item>
      <dxi-location
        screen="md lg"
        [row]="6"
        [col]="0"
        [colspan]="3"
      ></dxi-location>
      <dxi-location
        screen="xs sm"
        [row]="6"
        [col]="0"
        [colspan]="2"
      ></dxi-location>
      <div *dxTemplate class="signin-container">
        <span>
          Already have an account?
          <a (click)="btnBackToLogin()">Sign in</a>
        </span>
      </div>
    </dxi-item>
  </ng-container>

  <ng-container *ngIf="isUserCreated">
    <dxi-item>
      <dxi-location [row]="0" [col]="0" [colspan]="2"></dxi-location>
      <div *dxTemplate class="success-message">
        Your account has been successfully created and a confirmation email has
        been sent to you to activate the account. Please be aware that your Spam
        Protection may incorrectly identify the Activation Email as spam.
      </div>
    </dxi-item>
    <dxi-item>
      <dxi-location [row]="1" [col]="0" [colspan]="2"></dxi-location>
      <div *dxTemplate class="btn-wrapper btn-wrapper-align-center">
        <dx-button
          #btnLogin
          text="Back to Login"
          class="back-to-login-button"
          type="default"
          (onClick)="btnBackToLogin()"
        ></dx-button>
      </div>
    </dxi-item>
  </ng-container>
</dx-responsive-box>

<dx-load-panel
  #loadPanelLogin
  shadingColor="rgba(0,0,0,0.4)"
  [position]="{ of: '#emailCommunicationContainer' }"
  [(visible)]="loadingVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [hideOnOutsideClick]="false"
></dx-load-panel>

<cc-message-box #messageBox></cc-message-box>
